const API_key = 'UAgUD5ezDrtEOSpnA3eFEDQWjclEX3JM';

export default API_key;